import * as React from "react";
const SvgDropdownUp = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" style={{
  enableBackground: "new 0 0 100 100"
}} xmlSpace="preserve" width="1em" height="1em" {...props}><path className="dropdown-up_svg__st0" d="M50 39.3 87.8 75c2.8 2.6 7.3 2.6 10.1 0s2.8-6.9 0-9.5L55.1 25c-2.8-2.6-7.3-2.6-10.1 0L2.1 65.5c-2.8 2.6-2.8 6.9 0 9.5s7.3 2.6 10.1 0L50 39.3z" /></svg>;
export default SvgDropdownUp;